import React from 'react';
import RenderPlatformIcon from "../../components/RenderPlatformIcon.tsx";
import BackButton from "../../components/BackButton.tsx";
import {useDocumentTitle} from "usehooks-ts";

function LinkItem({platform, title}:{
    platform:'instagram' | 'facebook' | 'twitter',
    title: string;
}){
    const access_token = localStorage.getItem('access_token');
    return (
        <a href={`https://api.timelyturtle.com/oauth/connect/${platform}?access_token=${access_token}&platform=web${!import.meta.env.PROD ? '&mode=dev' : ''}`}
           className="flex gap-2 p-4 hover:text-primary">
            <RenderPlatformIcon platform={platform}/>
            <span>{title}</span>
        </a>
    )
}


function ConnectAccount() {
    useDocumentTitle("Connect Account")
    return (
        <div>
            <BackButton/>
            <h2 className={"text-2xl mb-1"}>Connect Account</h2>
            <p className={"opacity-75 mb-3"}>Connect your social media accounts for publishing posts</p>
            <div className="w-96 rounded-lg overflow-hidden shadow-md border border-base-200 divide-y divide-base-200">
                <LinkItem platform={"instagram"} title={"Instagram"} />
                <LinkItem platform={"facebook"} title={"Facebook"} />
                <LinkItem platform={"twitter"} title={"X (Twitter)"} />
            </div>

        </div>
    );
}

export default ConnectAccount;
